import React, { useCallback, useState } from 'react';
import cn from './../../lib/bem';
import contanto_asesor from './../../assets/svg/contacto_asesor.svg';
import ico_audifonos from './../../assets/svg/ico_audifonos.svg';

import './buttonFlotante_component.scss';
import { useSelector } from 'react-redux';
import { gtmOnclickHablarConAsesor } from '../../gtm/inicio';
import { baseUrl, queryParams } from './constants';

const ButtonFlotanteComponent = ({ mostrarModal }) => {
  const simuladorFVG = useSelector((state) => state.rootReducers.simuladorFVG);
  const classes = cn('buttonFlotanteComponent');
  const [activeContainer, setActiveContainer] = useState(false);

  const openContact = () => {
    setActiveContainer(!activeContainer);
  };

  const handleclickHablarConAsesor = useCallback(() => {
    if (simuladorFVG.nombreProspecto) {
      mostrarModal(true);
    } else {
      const fullUrl = `${baseUrl}?${queryParams.toString()}`;
      window.open(fullUrl, "_blank");
    }

    const pageTitle = localStorage.getItem("gtmPageTitle");
    gtmOnclickHablarConAsesor(pageTitle);
  }, [simuladorFVG.nombreProspecto, mostrarModal]);

  return (
    <div className={classes()}>
      <div className={classes('contact-texts-new')}>
        <img
          src={contanto_asesor}
          alt={'contacto'}
          onClick={handleclickHablarConAsesor}
        />
      </div>
      <button
        className={classes('contact-toggle-new')}
        id="openContact"
        onClick={() => openContact()}
      >
        <img
          src={ico_audifonos}
          alt={'ico_audifonos'}
          className={classes('classImage')}
        />
      </button>
    </div>
  );
};

export default ButtonFlotanteComponent;
